/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MergedUserSelfUpdateSettingsV1
 */
export interface MergedUserSelfUpdateSettingsV1 {
    /**
     * 
     * @type {boolean}
     * @memberof MergedUserSelfUpdateSettingsV1
     */
    arc_flash_detection_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MergedUserSelfUpdateSettingsV1
     */
    fall_detection_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MergedUserSelfUpdateSettingsV1
     */
    head_impact_detection_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MergedUserSelfUpdateSettingsV1
     */
    mute_sos_button: boolean;
    /**
     * 
     * @type {string}
     * @memberof MergedUserSelfUpdateSettingsV1
     */
    already_accepted_spec_etag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MergedUserSelfUpdateSettingsV1
     */
    already_accepted_pvd_etag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MergedUserSelfUpdateSettingsV1
     */
    already_accepted_emergency_etag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MergedUserSelfUpdateSettingsV1
     */
    language_code: string;
}

/**
 * Check if a given object implements the MergedUserSelfUpdateSettingsV1 interface.
 */
export function instanceOfMergedUserSelfUpdateSettingsV1(value: object): value is MergedUserSelfUpdateSettingsV1 {
    if (!('arc_flash_detection_on' in value) || value['arc_flash_detection_on'] === undefined) return false;
    if (!('fall_detection_on' in value) || value['fall_detection_on'] === undefined) return false;
    if (!('head_impact_detection_on' in value) || value['head_impact_detection_on'] === undefined) return false;
    if (!('mute_sos_button' in value) || value['mute_sos_button'] === undefined) return false;
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    return true;
}

export function MergedUserSelfUpdateSettingsV1FromJSON(json: any): MergedUserSelfUpdateSettingsV1 {
    return MergedUserSelfUpdateSettingsV1FromJSONTyped(json, false);
}

export function MergedUserSelfUpdateSettingsV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): MergedUserSelfUpdateSettingsV1 {
    if (json == null) {
        return json;
    }
    return {
        
        'arc_flash_detection_on': json['arc_flash_detection_on'],
        'fall_detection_on': json['fall_detection_on'],
        'head_impact_detection_on': json['head_impact_detection_on'],
        'mute_sos_button': json['mute_sos_button'],
        'already_accepted_spec_etag': json['already_accepted_spec_etag'] == null ? undefined : json['already_accepted_spec_etag'],
        'already_accepted_pvd_etag': json['already_accepted_pvd_etag'] == null ? undefined : json['already_accepted_pvd_etag'],
        'already_accepted_emergency_etag': json['already_accepted_emergency_etag'] == null ? undefined : json['already_accepted_emergency_etag'],
        'language_code': json['language_code'],
    };
}

export function MergedUserSelfUpdateSettingsV1ToJSON(json: any): MergedUserSelfUpdateSettingsV1 {
    return MergedUserSelfUpdateSettingsV1ToJSONTyped(json, false);
}

export function MergedUserSelfUpdateSettingsV1ToJSONTyped(value?: MergedUserSelfUpdateSettingsV1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'arc_flash_detection_on': value['arc_flash_detection_on'],
        'fall_detection_on': value['fall_detection_on'],
        'head_impact_detection_on': value['head_impact_detection_on'],
        'mute_sos_button': value['mute_sos_button'],
        'already_accepted_spec_etag': value['already_accepted_spec_etag'],
        'already_accepted_pvd_etag': value['already_accepted_pvd_etag'],
        'already_accepted_emergency_etag': value['already_accepted_emergency_etag'],
        'language_code': value['language_code'],
    };
}

